import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// @ts-ignore
import Line from '../../assets/line.png';
// @ts-ignore
import PinPoint from '../../assets/pin-point.png';

const drawerWidth = 240;
type NavProps = {
  open: boolean;
  drawerWidth?: string;
};

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<NavProps>(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const CustomLink = ({ label, url, active }: { label: string; url: string; active: boolean }) => {
  const style = { backgroundImage: `url(${Line})`, backgroundRepeat: 'no-repeat', backgroundSize: '30%', backgroundPosition: '3px -2px' };

  return (
    <Box pl={10} style={active ? style : {}}>
      <img src={PinPoint} width="14px" />
      <Typography ml={1} component={Link} to={url} style={{ textDecoration: 'none' }} color={active ? 'primary' : 'default'}>
        {label}
      </Typography>
    </Box>
  );
};

export default function DrawerD({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const location = useLocation();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(true);

  return (
    <Box sx={{ display: !matches ? 'flex' : 'block' }}>
      <CssBaseline />
      {
        matches && (
          <Box flex={2} display="flex" flexDirection="row" borderBottom="1px solid #F5F5F521" pb={2} mb={2}>
            <Box flex={1} textAlign="center">
              <Typography textTransform="uppercase" ml={1} component={Link} to="/summary" style={{ textDecoration: 'none' }} color={location.pathname === '/summary' ? 'primary' : 'default'}>
                Summary
              </Typography>
            </Box>
            <Box flex={1} textAlign="center">
              <Typography textTransform="uppercase" ml={1} component={Link} to="/performance" style={{ textDecoration: 'none' }} color={location.pathname === '/performance' ? 'primary' : 'default'}>
                Performance
              </Typography>
            </Box>
            <Box flex={1} textAlign="center">
              <Typography textTransform="uppercase" ml={1} component={Link} to="/users" style={{ textDecoration: 'none' }} color={location.pathname === '/users' ? 'primary' : 'default'}>
                Usuarios
              </Typography>
            </Box>
          </Box>
        )
      }
      {
        !matches && (
          <>
            {
              open && (
                <Box flex={2} borderRight={`3px solid ${theme.palette.primary.main}`} position="relative">
                  <Box display="flex">
                    <Box flex={3}>
                      <Box pl={8} pr={12}>
                        <Typography component={Link} to="/" color="primary" fontWeight="bold" fontSize="1.1rem" style={{ textDecoration: 'none' }}>
                          Dashboard
                        </Typography>
                      </Box>
                    </Box>
                    <Box flex={1}>
                      <Box textAlign="right">
                        <IconButton onClick={() => setOpen(false)} size="small" style={{ padding: 0 }}>
                          <ChevronLeftIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>

                  <CustomLink label="Summary" url="/summary" active={location.pathname === '/summary'} />
                  <CustomLink label="Performance" url="/performance" active={location.pathname === '/performance'} />
                  <CustomLink label="Usuarios" url="/users" active={location.pathname === '/users'} />
                  <Box pl={8}>
                    <Typography color="primary" fontWeight="bold" fontSize="1.1rem">
                      Ayuda
                    </Typography>
                  </Box>
                  <Box pl={5.6} style={{ backgroundImage: `url(${Line})`, backgroundRepeat: 'no-repeat', backgroundSize: '30%', backgroundPosition: '-32px -2px' }}>
                    <img src={PinPoint} width="14px" />
                    <Typography ml={0.5} component="a" href="https://auntap.atlassian.net/servicedesk/customer/portal/3" target="_blank" style={{ textDecoration: 'none' }}>
                      Portal de soporte
                    </Typography>
                  </Box>
                  <Box bottom="0" position="absolute">
                    <Typography variant="body2" align="center">
                      Proximamente más productos...
                    </Typography>
                  </Box>
                </Box>
              )
            }
            {
              !open && (
                <Box flex={1} borderRight={`3px solid ${theme.palette.primary.main}`}>
                  <Box textAlign="center">
                    <IconButton onClick={() => setOpen(true)} style={{ paddingBottom: 0 }}>
                      <MenuIcon fontSize="large" color="primary" />
                    </IconButton>
                  </Box>
                </Box>
              )
            }
          </>
        )
      }
      <Box flex={20} sx={{ px: { xs: 1, sm: 2, md: 8 } }}>
        {children}
      </Box>
    </Box>
  );
}
